module.exports = __webpack_public_path__ + "img/026-tank.c1a25c31.svg";